import React from "react";
import AccessCodeForm from "./AccessCodeForm";
import Countdown from "./Countdown";
import { REGISTRATION_OPENS_LABEL } from "../../config/event";

/** Shown on /reservations before the opening: countdown plus the early-access code form. */
const RegistrationGate = ({ timeLeft, onUnlocked }) => (
  <section className="access-gate" aria-labelledby="gate-heading">
    <h2 className="section-title" id="gate-heading">
      Registrace ještě není otevřená
    </h2>
    <p className="registration-info">
      Registrace se otevírá <b>{REGISTRATION_OPENS_LABEL}</b>. Máš přístupový kód? Zadej ho a můžeš rezervovat hned.
      Jeden kód platí pro jeden tým.
    </p>
    <Countdown timeLeft={timeLeft} />
    <AccessCodeForm idPrefix="gate-access" onUnlocked={onUnlocked} />
  </section>
);

export default RegistrationGate;
